const receiptContent = ({
  CinemaName = "Sarit",
  ShowDate = "",
  ShowTime = "",
  CustomerName = "",
  SeatNumbers = "",
  MovieName = "",
  TotalCost = "",
  PaymentMethod = "",
  BookingID = "42345",
}) => ({
  CinemaName,
  ShowDate,
  ShowTime,
  CustomerName,
  SeatNumbers,
  MovieName,
  TotalCost,
  PaymentMethod,
  BookingID,
});

export { receiptContent };
